import { db } from '@/api/firebase';
import { useToast } from '@/components/ui/use-toast';
import { deleteDoc, doc, getDoc, updateDoc } from 'firebase/firestore';
import { useState } from 'react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useMainContext } from '@/context/main-context';

function DeletePaymentAlert({ paymentId, open, setOpen }) {
  const { toast } = useToast();
  const { uid, students, paymentHistory } = useMainContext();

  const [loading, setLoading] = useState(false);

  const payment = paymentHistory.find((p) => p.id === paymentId);
  const student = students.find((s) => s.id === payment?.studentId);

  const deletePayment = async () => {
    setLoading(true);
    try {
      const paymentDocRef = doc(db, `users/${uid}/paymentHistory`, paymentId);
      await deleteDoc(paymentDocRef);

      const studentRef = doc(db, 'students', student.id);
      const studentDoc = await getDoc(studentRef);

      if (studentDoc.exists()) {
        const studentData = studentDoc.data();

        const updatedPaymentHistory = studentData.paymentHistory.filter(
          (p) => p.paymentId !== paymentId
        );

        await updateDoc(studentRef, {
          paymentHistory: updatedPaymentHistory,
        });

        toast({
          title: 'To‘lov muvaffaqiyatli o‘chirildi',
        });
        setOpen(false);
      } else {
        throw new Error("O'quvchi ma'lumotlari topilmadi.");
      }
    } catch (error) {
      console.error('Error deleting payment:', error);
      toast({
        title: 'Xato yuz berdi',
        description: 'To‘lovni o‘chirishda xato yuz berdi.',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Siz mutlaqo ishonchingiz komilmi?</AlertDialogTitle>
          <AlertDialogDescription>
            Bu amalni ortga qaytarib bo‘lmaydi. Bu sizning hisobingizni butunlay
            o'chirib tashlaydi va ma'lumotlaringizni serverlarimizdan olib
            tashlaydi.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Bekor qilish</AlertDialogCancel>
          <AlertDialogAction onClick={deletePayment}>
            {loading ? "O'chirilmoqda..." : "O'chirish"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default DeletePaymentAlert;
